import React, { useEffect, useState } from 'react';
import * as API from "../../framework/API/api";
import { ENTITYNAME, LOGEVENT, MODULE, VALIDATION_LEVEL_TYPE, VALIDATION_TYPE, DATA_TYPE, BOOLEAN_STATUS, DATETIMEFORMATS, TOAST_TYPES } from "../../framework/constant/constant";
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import { EditPageHeader } from '../../components/EditPageHeader';
import BossDialog from '../../components/BossDialog';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { ConfirmDeleteAlert } from '../../ConfirmAlert';
import ToastNotification from '../../components/ToastNotification';

const FieldValidationEditForm = (props) => {
    const lang = useTranslation();
    const blankDataItem = {
        ...props?.item,
        ValidationLevel: props?.item?.ValidationLevel ? { _id: props?.item?.ValidationLevel, Description: utility.getKeyByValue(VALIDATION_LEVEL_TYPE, props?.item?.ValidationLevel) } : null,
        Channel: props?.item?.Channel ?? {},
        FormField: props?.item?.FormField ?? {},
        EntityName: props?.item?.EntityName ? { _id: props?.item?.EntityName, Description: utility.getKeyByValue(ENTITYNAME, props?.item?.EntityName) } : {},
    };
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [validationLevels, setValidationLevels] = useState([]);
    const [channels, setChannels] = useState([]);
    const [formFields, setFormFields] = useState([]);
    const [validationTypes, setValidationTypes] = useState([]);
    const [valueTypes, setValueTypes] = useState([]);
    const [entityNames, setEntityNames] = useState([]);

    const generateId = () => {
        return Date.now().toString(36) + Math.random().toString(36).substring(2);
    };

    const [validations, setValidations] = useState(
        props?.item?.Validations?.map(v => {
            let convertedValue = v?.Value ?? null;

            if (v?.ValidationType === VALIDATION_TYPE.DATA_TYPE) {

                // if (v?.DataType === DATA_TYPE.DATE && v?.Value) { convertedValue = utility.convertMilisecondsToDateString(v.Value); }
                // if (v?.DataType === DATA_TYPE.TIME && v?.Value) { convertedValue = utility.convertMilisecondsToShortTimeString(v.Value); }
                if (v?.DataType === DATA_TYPE.DATE) { convertedValue = v?.Value ? DATETIMEFORMATS.find(x => x.Type === v?.Value) : "" }
                if (v?.DataType === DATA_TYPE.TIME) { convertedValue = v?.Value ? DATETIMEFORMATS.find(x => x.Type === v?.Value) : "" }
                if (v?.DataType === DATA_TYPE.BOOLEAN && v?.Value !== null) { convertedValue = { _id: v?.Value, Description: utility.getKeyByValue(BOOLEAN_STATUS, v.Value) }; }
            }
            return {
                id: generateId(),
                ValidationType: v?.ValidationType ? { _id: v?.ValidationType, Description: utility.getKeyByValue(VALIDATION_TYPE, v?.ValidationType) } : null,
                Value: convertedValue,
                DataType: v?.DataType ? { _id: v?.DataType, Description: utility.getKeyByValue(DATA_TYPE, v?.DataType) } : null,
                EntityName: v?.EntityName ? { _id: v?.EntityName, Description: utility.getKeyByValue(ENTITYNAME, v?.EntityName) } : null,
                ErrorMessage: v?.ErrorMessage ?? ""
            }
        }) ?? []
    );
    const [editIndex, setEditIndex] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isBoolean, setIsBoolean] = useState([]);

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        const isBooleanRes = Object.keys(BOOLEAN_STATUS).map(x => ({
            _id: BOOLEAN_STATUS[x],
            Description: x
        }));
        setIsBoolean(isBooleanRes);
        const validationLevelRes = Object.keys(VALIDATION_LEVEL_TYPE).map(x => ({
            _id: VALIDATION_LEVEL_TYPE[x],
            Description: x
        }));
        setValidationLevels(validationLevelRes);
        const channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        setChannels(channelRes.data);
        const validationTypeRes = Object.keys(VALIDATION_TYPE).map(x => ({
            _id: VALIDATION_TYPE[x],
            Description: x
        }));
        setValidationTypes(validationTypeRes);
        const valueTypeRes = Object.keys(DATA_TYPE).map(x => ({
            _id: DATA_TYPE[x],
            Description: x
        }));
        setValueTypes(valueTypeRes);
        const entityNameRes = Object.keys(ENTITYNAME).map(x => ({
            _id: ENTITYNAME[x],
            Description: x
        }));
        setEntityNames(entityNameRes);
    }

    useEffect(() => {
        if (dataItem.EntityName?._id) {
            loadFormFields(dataItem.EntityName._id);
        }
    }, [dataItem.EntityName]);

    const loadFormFields = async (entityName) => {
        const formFieldRes = await API.getData(ENTITYNAME.FormFields, { query: ['entityName', '=', entityName] });
        setFormFields(formFieldRes.data);
    }

    const onChange = (e) => {
        if (e.target.name === "EntityName") {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value, FormField: {} });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const validationChange = (index, key, value) => {
        setValidations(prev => {
            if (!prev[index]) return prev;
            const next = [...prev];
            const item = { ...next[index] };

            if (key === "ValidationType") {
                item.ValidationType = value;
                item.Value = "";
                item.DataType = null;
                item.EntityName = null;
            } else if (key === "DataType") {
                item.DataType = value;
            } else {
                item[key] = value;

                if (key === "DataType") {
                    item.Value = "";
                }
            }
            next[index] = item;
            return next;
        });
    };

    const addValidationRow = () => {
        if (editIndex !== null) return;
        const newValidation = {
            id: generateId(),
            ValidationType: null,
            Value: "",
            DataType: null,
            EntityName: null,
            ErrorMessage: ""
        };
        setValidations(prev => [...prev, newValidation]);
        setEditIndex(validations.length);
    };

    const removeValidationRow = (index) => {
        setValidations(prev => {
            const list = [...prev];
            list.splice(index, 1);
            return list;
        });
        if (editIndex === index) setEditIndex(null);
    };

    const isValid = () => {

        if (!dataItem.ValidationLevel?._id) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_validation_level_error_message });
            return false;
        }

        if (dataItem.ValidationLevel?._id === VALIDATION_LEVEL_TYPE.CHANNEL && !dataItem.Channel?._id) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }

        if (!dataItem.EntityName || Object.keys(dataItem.EntityName).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_entity_name_error_message });
            return false;
        }

        if (!dataItem.FormField || Object.keys(dataItem.FormField).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_form_field_error_message });
            return false;
        }

        if (!validations || validations.length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_add_atleast_one_validation_type_error_message });
            return false;
        }

        for (let i = 0; i < validations.length; i++) {

            const val = validations[i];

            if (!val?.ValidationType?._id) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Validation ${i + 1}: ${lang.please_select_validation_type_error_message}` });
                return false;
            }
            const type = val.ValidationType._id;

            /* REQUIRED */
            if (type === VALIDATION_TYPE.REQUIRED) {
                if (!val?.ErrorMessage?.trim()) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Validation ${i + 1}: ${lang.please_enter_error_message}` });
                    return false;
                }
            }

            /* MIN MAX LENGTH / VALUE */
            if (
                type === VALIDATION_TYPE.MIN_LENGTH ||
                type === VALIDATION_TYPE.MAX_LENGTH ||
                type === VALIDATION_TYPE.MIN_VALUE ||
                type === VALIDATION_TYPE.MAX_VALUE
            ) {
                if (!val?.Value) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Validation ${i + 1}: ${lang.please_enter_value_error_message}` });
                    return false;
                }
            }
            /* REGEX */
            if (type === VALIDATION_TYPE.REGEX_PATTERN) {
                if (!val?.Value?.trim()) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Validation ${i + 1}: ${lang.please_enter_pattern_error_message}` });
                    return false;
                }
            }
            /* ALLOWED VALUES */
            if (type === VALIDATION_TYPE.ALLOWED_VALUES) {
                if (!val?.Value?.trim()) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Validation ${i + 1}: ${lang.please_enter_allowed_values_error_message}`});
                    return false;
                }
            }
            /* LOOKUP */
            if (type === VALIDATION_TYPE.LOOKUP_VALIDATION) {

                if (!val?.EntityName?._id) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message:`Validation ${i + 1}: ${lang.please_select_entityname_error_message}`});
                    return false;
                }
                if (!val?.Value?.trim()) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Validation ${i + 1}: ${lang.please_enter_fields_error_message}`});
                    return false;
                }
            }
            /* DATA TYPE */
            if (type === VALIDATION_TYPE.DATA_TYPE) {
                if (!val?.DataType?._id) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Validation ${i + 1}: ${lang.please_select_data_type_error_message}` });
                    return false;
                }
                // Only DATE and TIME require format
                if ( (val?.DataType?._id === DATA_TYPE.DATE || val?.DataType?._id === DATA_TYPE.TIME) && !val?.Value) 
                    {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Validation ${i + 1}: ${lang.please_select_format_error_message}` });
                    return false;
                }

                // if (val?.Value === null || val?.Value === undefined || val?.Value === "") {
                //     ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Validation ${i + 1}: ${lang.please_enter_value_error_message}` });
                //     return false;
                // }
            }

            // if (!val.ErrorMessage?.trim()) {
            //     ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Validation Type ${i + 1}: ${lang?.please_enter_error_message}` });
            //     return false;
            // }
        }
        return true;
    };

    const handleSubmit = async () => {
        if (!isValid()) return;

        setLoading(true);
        const saveData = {
            _id: dataItem._id,
            SID: dataItem.SID,
            ValidationLevel: dataItem?.ValidationLevel?._id ?? null,
            Channel: dataItem?.Channel && Object.keys(dataItem?.Channel).length > 0 ? {
                _id: dataItem?.Channel?._id,
                ShortChannelName: dataItem?.Channel?.ShortChannelName,
                FullChannelName: dataItem?.Channel?.FullChannelName
            } : {},
            FormField: dataItem?.FormField && Object.keys(dataItem?.FormField).length > 0 ? {
                _id: dataItem?.FormField?._id,
                name: dataItem?.FormField?.name,
                label: dataItem?.FormField?.label,
                type: dataItem?.FormField?.type
            } : {},
            EntityName: dataItem?.EntityName?._id ?? null,
            Validations: validations.map(val => {

                let finalValue = val?.Value ?? "";

                if (
                    val?.ValidationType?._id === VALIDATION_TYPE.MIN_LENGTH ||
                    val?.ValidationType?._id === VALIDATION_TYPE.MAX_LENGTH ||
                    val?.ValidationType?._id === VALIDATION_TYPE.MIN_VALUE ||
                    val?.ValidationType?._id === VALIDATION_TYPE.MAX_VALUE
                ) {
                    finalValue = val?.Value !== "" ? parseInt(val.Value) : null;
                }
                if (val?.ValidationType?._id === VALIDATION_TYPE.DATA_TYPE) {
                    // if (val?.DataType?._id === DATA_TYPE.DATE && val?.Value) {
                    //     finalValue = utility.convertStringDatetoMilliseconds(val.Value);
                    // }
                    // if (val?.DataType?._id === DATA_TYPE.TIME && val?.Value) {
                    //     finalValue = utility.convertShortTimeStringToMilliSeconds(val.Value);
                    // }
                    if (val?.DataType?._id === DATA_TYPE.DATE) {
                        finalValue = val?.Value?.Type;
                    }
                    if (val?.DataType?._id === DATA_TYPE.TIME) {
                        finalValue = val?.Value?.Type;
                    }
                    if (val?.DataType?._id === DATA_TYPE.NUMERIC && val?.Value !== "") {
                        finalValue = val?.Value !== "" ? parseInt(val.Value) : null;
                    }
                    if (val?.DataType?._id === DATA_TYPE.BOOLEAN) {
                        finalValue = val?.Value?._id ?? false;
                    }
                }
                return {
                    ValidationType: val?.ValidationType?._id ?? null,
                    Value: finalValue,
                    DataType: val?.DataType?._id ?? null,
                    EntityName: val?.EntityName?._id ?? null,
                    ErrorMessage: val?.ErrorMessage ?? ""
                }
            })
        };
        console.log(saveData);
        const res = await API.saveData(ENTITYNAME.FieldValidation, saveData);
        if (res.success) {
            const logData = { event: res.message === "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.FIELD_VALIDATION, data: res.data, message: res.message };
            API.SaveLogs(logData);
            props.cancelEdit();
            props.refresh();
            utility.deleteLocalStorageItem(ENTITYNAME.FieldValidation);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        setLoading(false);
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    const renderValueInput = (val, index, isEditing) => {

        switch (val?.DataType?._id) {
            case DATA_TYPE.NUMERIC:
                return (
                    <>
                        <label>{lang.number_label}</label>
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            value={val.Value || ""}
                            onChange={(e) => validationChange(index, "Value", e.target.value)}
                            min="0"
                            disabled={!isEditing}
                        />
                    </>
                );
            case DATA_TYPE.TEXT:
                return (
                    <>
                        <label>{lang.text_label}</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            value={val.Value || ""}
                            onChange={(e) => validationChange(index, "Value", e.target.value)}
                            disabled={!isEditing}
                        />
                    </>
                );
            case DATA_TYPE.DATE:
                return (
                    <>
                        <label htmlFor="">{lang.format_label} *</label>
                        <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={DATETIMEFORMATS}
                            textField="Type"
                            dataItemKey="ID"
                            value={val.Value || null}
                            disabled={!isEditing}
                            onChange={(e) => validationChange(index, "Value", e.target.value)}
                        />
                        {/* <label>{lang.date_label}</label>
                        <input
                            type="date"
                            className="form-control form-control-sm"
                            value={val.Value || ""}
                            onChange={(e) => validationChange(index, "Value", e.target.value)}
                            disabled={!isEditing}
                        /> */}
                    </>
                );
            case DATA_TYPE.TIME:
                return (
                    <>
                        <label htmlFor="">{lang.format_label} *</label>
                        <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={DATETIMEFORMATS}
                            textField="Type"
                            dataItemKey="ID"
                            value={val.Value || null}
                            disabled={!isEditing}
                            onChange={(e) => validationChange(index, "Value", e.target.value)}
                        />
                        {/* <label>{lang.time_label}</label>
                        <input
                            type="time"
                            className="form-control form-control-sm"
                            value={val.Value || ""}
                            onChange={(e) => validationChange(index, "Value", e.target.value)}
                            disabled={!isEditing}
                        /> */}
                    </>
                );
            case DATA_TYPE.BOOLEAN:
                return (
                    <>
                        <label>{lang.boolean_label}</label>
                        <DropDownList
                            data={isBoolean}
                            textField="Description"
                            dataItemKey="_id"
                            value={val.Value || null}
                            disabled={!isEditing}
                            onChange={(e) => validationChange(index, "Value", e.target.value)}
                        />
                    </>
                );
            default:
                return (
                    <>
                        <label>{lang.any_label}</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            value={val.Value || ""}
                            onChange={(e) => validationChange(index, "Value", e.target.value)}
                            disabled={!isEditing}
                        />
                    </>
                );
        }
    };

    return (
        <BossDialog title={lang.field_validation_dialog_header} onClose={props.cancelEdit} width="900px">
            <EditPageHeader title="" onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} disabled={loading} />
            <div className='row mt-2'>
                <div className='col-4'>
                    <label>{lang.validation_level_label} *</label>
                    <DropDownList
                        className="form-control form-control-sm"
                        data={validationLevels}
                        name="ValidationLevel"
                        textField="Description"
                        dataItemKey="_id"
                        onChange={onChange}
                        value={dataItem.ValidationLevel || null}
                    />
                </div>
                {dataItem?.ValidationLevel?._id === VALIDATION_LEVEL_TYPE.CHANNEL && (
                    <div className="col-4">
                        <label>{lang.channel_label} *</label>
                        <DropDownList
                            className="form-control form-control-sm"
                            data={channels}
                            name="Channel"
                            textField="FullChannelName"
                            dataItemKey="_id"
                            onChange={onChange}
                            value={dataItem.Channel || null}
                        />
                    </div>
                )}
                <div className='col-4'>
                    <label>{lang.entity_name_label} *</label>
                    <DropDownList
                        className="form-control form-control-sm"
                        data={entityNames}
                        name="EntityName"
                        textField="Description"
                        dataItemKey="_id"
                        onChange={onChange}
                        value={dataItem.EntityName || null}
                    />
                </div>
                <div className={dataItem?.ValidationLevel?._id === VALIDATION_LEVEL_TYPE.CHANNEL ? "col-4 mt-2" : "col-4"}>
                    <label>{lang.form_field_label} *</label>
                    <DropDownList
                        className="form-control form-control-sm"
                        data={formFields}
                        name="FormField"
                        textField="label"
                        dataItemKey="_id"
                        onChange={onChange}
                        value={dataItem.FormField || null}
                    />
                </div>
            </div>
            {/* Validation Rules Section */}
            <div style={{ marginTop: "20px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" }}>
                    <span style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: "#5b7cfa" }}>{lang.validation_type_label}
                    </span>
                    <div style={{ flex: 1, height: "1px", background: "linear-gradient(90deg, #e2e6ed 0%, transparent 100%)" }} />
                    <span style={{ fontSize: "12px", color: "#8b929e", fontWeight: 500 }}>
                        {validations.length} type{validations.length !== 1 ? "s" : ""}
                    </span>
                </div>
                <div style={{ minHeight: "140px", maxHeight: "281px", overflowY: "auto", paddingRight: "4px", scrollbarWidth: "none" }}>
                    {validations.length === 0 ? (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 20px", background: "#f8f9fc", border: "1.5px dashed #d1d5db", borderRadius: "10px", color: "#adb5bd", textAlign: "center" }}>
                            <svg width="32" height="32"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                style={{ marginBottom: "10px", opacity: 0.5 }}>
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                <line x1="12" y1="8" x2="12" y2="12" />
                                <line x1="12" y1="16" x2="12.01" y2="16" />
                            </svg>
                            <div style={{ fontSize: "13px", fontWeight: 600, color: "#6b7280" }}>{lang.no_validation_type_message} </div>
                            <div style={{ fontSize: "12px", marginTop: "4px" }}>{lang.add_type_message}</div>
                        </div>
                    ) : (
                        validations.map((val, index) => {
                            const isEditing = editIndex === index;
                            return (
                                <div key={val.id} style={{ background: isEditing ? "#fff" : "#f8f9fc", border: isEditing ? "1.5px solid #5b7cfa" : "1.5px solid #eaecf0", borderRadius: "10px", padding: "14px 16px", marginBottom: "10px" }}>
                                    <div style={{ display: "flex", gap: "12px", alignItems: "flex-end", flexWrap: "wrap" }}>

                                        {/* Validation Type */}
                                        <div style={{ flex: "0 0 160px" }}>
                                            <label> {lang.validation_type_label} * </label>
                                            <DropDownList
                                                data={validationTypes}
                                                textField="Description"
                                                dataItemKey="_id"
                                                value={val.ValidationType || null}
                                                disabled={!isEditing}
                                                onChange={(e) => validationChange(index, "ValidationType", e.target.value)}
                                            />
                                        </div>
                                        {val?.ValidationType?._id &&
                                            val?.ValidationType?._id !== VALIDATION_TYPE.REQUIRED && (
                                                <>
                                                    {/* NUMBER RULES */}
                                                    {(val?.ValidationType?._id === VALIDATION_TYPE.MIN_LENGTH ||
                                                        val?.ValidationType?._id === VALIDATION_TYPE.MAX_LENGTH ||
                                                        val?.ValidationType?._id === VALIDATION_TYPE.MIN_VALUE ||
                                                        val?.ValidationType?._id === VALIDATION_TYPE.MAX_VALUE || val?.ValidationType?._id === VALIDATION_TYPE.FIXED_LENGTH) && (
                                                            <div style={{ flex: "0 0 120px" }}><label> {lang.value_label} * </label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control form-control-sm"
                                                                    placeholder="Value"
                                                                    value={val.Value || ""}
                                                                    disabled={!isEditing}
                                                                    min="0"
                                                                    onChange={(e) => validationChange(index, "Value", e.target.value)}
                                                                />
                                                            </div>
                                                        )}

                                                    {/* REGEX */}
                                                    {val?.ValidationType?._id === VALIDATION_TYPE.REGEX_PATTERN && (
                                                        <div style={{ flex: "1 1 160px" }}>
                                                            <label> {lang.pattern_label} *</label>
                                                            <input
                                                                className="form-control form-control-sm"
                                                                placeholder="Regex Pattern"
                                                                value={val.Value || ""}
                                                                disabled={!isEditing}
                                                                onChange={(e) => validationChange(index, "Value", e.target.value)}
                                                            />
                                                        </div>
                                                    )}

                                                    {/* LOOKUP */}
                                                    {val?.ValidationType?._id === VALIDATION_TYPE.LOOKUP_VALIDATION && (
                                                        <>
                                                            <div style={{ flex: "0 0 150px" }}>
                                                                <label>{lang.entity_name_label} *</label>
                                                                <DropDownList
                                                                    data={entityNames}
                                                                    textField="Description"
                                                                    dataItemKey="_id"
                                                                    value={val.EntityName || null}
                                                                    disabled={!isEditing}
                                                                    onChange={(e) => validationChange(index, "EntityName", e.target.value)}
                                                                />
                                                            </div>
                                                            <div style={{ flex: "0 0 130px" }}>
                                                                <label> {lang.fields_label} *</label>
                                                                <input
                                                                    className="form-control form-control-sm"
                                                                    placeholder="Fields"
                                                                    value={val.Value || ""}
                                                                    disabled={!isEditing}
                                                                    onChange={(e) => validationChange(index, "Value", e.target.value)}
                                                                />
                                                            </div>
                                                        </>
                                                    )}

                                                    {/* DATA TYPE */}
                                                    {val?.ValidationType?._id === VALIDATION_TYPE.DATA_TYPE && (
                                                        <>
                                                            <div style={{ flex: "0 0 140px" }}>
                                                                <label> {lang.data_type_label} *</label>
                                                                <DropDownList
                                                                    data={valueTypes}
                                                                    textField="Description"
                                                                    dataItemKey="_id"
                                                                    value={val.DataType || null}
                                                                    disabled={!isEditing}
                                                                    onChange={(e) => validationChange(index, "DataType", e.target.value)}
                                                                />
                                                            </div>
                                                            <div style={{ flex: "0 0 160px" }}>
                                                                {renderValueInput(val, index, isEditing)}
                                                            </div>
                                                        </>
                                                    )}

                                                    {/* ALLOWED VALUES */}
                                                    {val?.ValidationType?._id === VALIDATION_TYPE.ALLOWED_VALUES && (
                                                        <div style={{ flex: "1 1 200px" }}>
                                                            <label> {lang.allowed_values_label} *</label>
                                                            <input
                                                                className="form-control form-control-sm"
                                                                placeholder="comma separated"
                                                                value={val.Value || ""}
                                                                disabled={!isEditing}
                                                                onChange={(e) => validationChange(index, "Value", e.target.value)}
                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            )}

                                        {/* ERROR */}
                                        <div style={{ flex: "1 1 180px" }}>
                                            <label>{lang.error_message_label}
                                                {val?.ValidationType?._id === VALIDATION_TYPE.REQUIRED && (<span style={{ color: "black" }}> *</span>)}
                                            </label>
                                            <input
                                                className="form-control form-control-sm"
                                                placeholder="Error Message"
                                                value={val.ErrorMessage || ""}
                                                disabled={!isEditing}
                                                onChange={(e) => validationChange(index, "ErrorMessage", e.target.value)}
                                            />
                                        </div>

                                        {/* ACTIONS */}
                                        <div style={{ display: "flex", gap: "6px", alignSelf: "flex-end", paddingBottom: "1px" }}>
                                            {!isEditing ? (
                                                <button
                                                    onClick={() => setEditIndex(index)}
                                                    title="Edit"
                                                    style={{ display: "flex", alignItems: "center", gap: "5px", padding: "7px 12px", background: "#fff", border: "1.5px solid #e2e6ed", borderRadius: "7px", cursor: "pointer", fontSize: "12px", fontWeight: 600, color: "#5b7cfa", transition: "all 0.15s" }}>
                                                    {lang.edit_label}
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={() => setEditIndex(null)}
                                                    title="Done"
                                                    style={{ display: "flex", alignItems: "center", gap: "5px", padding: "7px 12px", background: "#10b981", border: "1.5px solid #10b981", borderRadius: "7px", cursor: "pointer", fontSize: "12px", fontWeight: 600, color: "#fff" }}
                                                >
                                                    {lang.done_label}
                                                </button>
                                            )}
                                            <button onClick={() => ConfirmDeleteAlert(() => removeValidationRow(index), () => { })}
                                                title="Delete"
                                                style={{ display: "flex", alignItems: "center", padding: "7px 10px", background: "#fff", border: "1.5px solid #e2e6ed", borderRadius: "7px", cursor: "pointer", color: "#e85d75" }}
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
                <button
                    onClick={addValidationRow}
                    disabled={editIndex !== null || loading}
                    style={{
                        marginTop: "12px", display: "flex", alignItems: "center", gap: "6px",
                        padding: "9px 16px", border: "1.5px dashed #c7d0e8", borderRadius: "8px",
                        background: editIndex !== null ? "#f8f9fb" : "#fff",
                        color: editIndex !== null ? "#adb5bd" : "#5b7cfa",
                        cursor: editIndex !== null ? "not-allowed" : "pointer",
                        fontSize: "13px", fontWeight: 600, width: "100%", justifyContent: "center",
                        transition: "all 0.15s",
                    }}
                    onMouseEnter={(e) => {
                        if (editIndex === null) {
                            e.currentTarget.style.background = "#f0f4ff";
                            e.currentTarget.style.borderColor = "#5b7cfa";
                        }
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = editIndex !== null ? "#f8f9fb" : "#fff";
                        e.currentTarget.style.borderColor = "#c7d0e8";
                    }}
                >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="12" y1="5" x2="12" y2="19" />
                        <line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                    {lang.add_validation_type_label}
                </button>
            </div>
        </BossDialog>
    );
};

export default FieldValidationEditForm;




